import { render, staticRenderFns } from "./DesignListTabular.vue?vue&type=template&id=3f96f6f2&scoped=true&"
import script from "./DesignListTabular.vue?vue&type=script&lang=js&"
export * from "./DesignListTabular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96f6f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
